import React from "react";
import { Stack, Text, DefaultButton, Icon } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import Tr from "../../Utils/Translations/Translations";
import { mobileCheck } from "../../App";
import { AppRoutes } from "../../AppRoutes";

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <Stack
      verticalAlign="center"
      horizontalAlign="center"
      styles={{
        root: {
          height: "100vh",
          width: "100%",
          padding: "2em",
          textAlign: "center",
        },
      }}
      tokens={{ childrenGap: 20 }}
    >
      <Icon
        iconName="PaymentCardError"
        styles={{
          root: {
            fontSize: mobileCheck() ? 80 : 120,
            color: "#A80000", // Rosso scuro
          },
        }}
      />

      <Text variant="xxLarge" styles={{ root: { fontWeight: 600 } }}>
        {Tr.Translate("language", "payment_cancelled_title")}
      </Text>

      <Text variant="large">
        {Tr.Translate("language", "payment_cancelled_desc")}
      </Text>

      <div style={{ marginTop: "2em" }}>
        <DefaultButton
          text={Tr.Translate("language", "return_to_store")}
          onClick={() => navigate(AppRoutes.STORE_PAGE)} // Modifica con la rotta del tuo store
          styles={{ root: { padding: "1.5em", minWidth: "200px" } }}
        />
      </div>
    </Stack>
  );
};

export default PaymentCancelledPage;
